import { useCallback, useSyncExternalStore } from 'react'
import { useAuth } from '../contexts/AuthContext'
import {
  UserPreferences,
  getPreferences,
  setPreferences,
  subscribePreferences,
} from '../services/preferencesService'

/** Preferencias de interfaz del usuario activo. */
export function usePreferences(): [
  UserPreferences,
  (patch: Partial<UserPreferences>) => void,
] {
  const { user } = useAuth()
  const userId = user?.id ?? 'anon'

  const preferences = useSyncExternalStore(
    subscribePreferences,
    () => getPreferences(userId),
    () => getPreferences(userId),
  )

  const update = useCallback(
    (patch: Partial<UserPreferences>) => setPreferences(userId, patch),
    [userId],
  )

  return [preferences, update]
}
